import Helper from '@ember/component/helper';
import moment from 'moment-timezone';

export function duration(
  [start, end],
  { fallback = 'invalid duration', forceNumberPrefix = false, forceSingular = false } = {},
) {
  // handling single value: understood as "end"
  if (typeof end === 'undefined') {
    end = start;
    start = 0;
  }

  if ((!start && start !== 0) || (!end && end !== 0) || start === end) {
    return fallback;
  }

  let result = moment.unix(start).from(moment.unix(end), true);

  // forceNumberPrefix option results in number always being present in output string instead of singular "a"/"an" prefix
  // examples:
  // "a minute" -> "1 minute"
  // "an hour" -> "1 hour"
  // "a day" -> "1 day"
  // "a month" -> "1 month"
  //
  // .length === 2 check is there to ensure some specific cases are not incorrectly formatted
  // e.g. "a few seconds" (any number of seconds less than 45)
  if (forceNumberPrefix && result.split(' ').length === 2) {
    result = result.replace(/^an?/, '1');
  }

  // forceSingular option always returns noun in singular form
  // examples:
  // "2 minutes" -> "2 minute"
  // "5 hours" -> "5 hour"
  //
  // special case: "a few seconds", where "seconds" are still plural; "a few" is the singular form part
  if (forceSingular && result.split(' ').length === 2) {
    result = result.replace(/s$/, '');
  }

  return result;
}

export default Helper.helper(duration);
